var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.producer))]),_vm._v(" submitted an update, changing "+_vm._s(_vm.summary)+": ")]),_c('div',{staticClass:"field-list"},[_vm._v(" "+_vm._s(_vm.changedFields.join(', '))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }